import React, { PropTypes, Component } from 'react';
import * as Icons from 'components/Icons';
import * as Colors from 'components/Material/Styles/Colors';
import { Paper, Styles, TextField } from 'material-ui';
import { CourseActions } from 'actions';
import { CourseStore } from 'stores';

const { Spacing } = Styles;

const styles = {
  root: {
    position: 'relative',
    paddingTop: Spacing.iconSize + Spacing.desktopGutterMini / 2
  },
  icon: {
    cursor: 'pointer',
    position: 'absolute',
    right: 0,
    top: 0
  },
  colorChooser: {
    position: 'absolute',
    top: 48,
    left: 48
  },
  arrow: {
    cursor: 'pointer'
  },
  colorChoice: {
    cursor: 'pointer',
    display: 'inline-block',
    height: 24,
    width: 24,
    margin: Spacing.desktopGutterMini / 4
  },
  note: {
    paddingLeft: 48,
    paddingRight: 28
  }
};

const css = oxygenCss({
  root: {
    position: 'relative'
  }
});

export default class Note extends Component {
  static defaultProps = {
    color: 'coursio'
  };

  static contextTypes = {
    getIntlMessage: PropTypes.func
  };

  listenToStores() {
    this.listenToStore(CourseStore);
  }

  state = {
    open: false,
    color: this.props.text.trim().length === 0 ? 'coursio' : 'red',
    //color: this.props.color,
    mouseOver: false
  };

  getIconStyle() {
    return Object.assign(
      {
        transform: !this.state.open ? 'scale(1, 1)' : 'scale(-1, 1)'
      },
      styles.icon
    );
  }

  mouseEnter() {
    if (!this.state.open) {
      return;
    }
    if (this._timer) {
      clearTimeout(this._timer);
      this._timer = null;
    }
    if (this._outTimer) {
      this._outTimer = null;
      clearTimeout(this._outTimer);
    }
    this._timer = setTimeout(() => {
      this._timer = null;
      this.setState({ mouseOver: true });
    }, 1000);
  }

  mouseLeave() {
    this._outTimer = setTimeout(() => {
      this._outTimer = null;
      this.setState({ mouseOver: false });
    }, 1000);
  }

  getNoteStyle() {
    return Object.assign(
      {
        minWidth: Spacing.desktopKeylineIncrement * 3,
        minHeight: 50
      },
      styles.note
    );
  }

  toggle() {
    if (this.state.open) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    if (!this.state.open) {
      this.setState({ open: true });
      if (this.props.onEnable) {
        this.props.onEnable();
      }
    }
  }

  close() {
    if (this.state.open) {
      this.setState({ open: false, mouseOver: false });
      if (this.props.onDisable) {
        this.props.onDisable();
      }
    }
  }

  /*  chooseColor(color) {
    this.setState({ color });
    this.save();
  }*/

  save() {
    const { pageModuleId } = this.props;
    if (this._saveTimer) {
      clearTimeout(this._saveTimer);
    }
    this._saveTimer = setTimeout(() => {
      const noteText = this.refs.noteText.getValue();
      const color = this.state.color;
      if (noteText.trim().length != 0) {
        this.setState({ noteText, color: 'red' });
      } else {
        this.setState({ noteText, color: 'coursio' });
      }
      CourseActions.note(pageModuleId, noteText, color);
    }, 500);
  }

  render() {
    const { text } = this.props;
    const { color } = this.state;
    const materialColor = Colors.Colors[color];
    const iconColor = materialColor[400].material;
    const hoverColor = materialColor[200].material;
    let noteText, colorChooser;
    // if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))
    if (this.state.open) {
      noteText = (
        <TextField
          ref="noteText"
          defaultValue={this.state.noteText || this.props.text}
          onChange={::this.save}
          underlineFocusStyle={{ borderColor: materialColor[500].material }}
          defaultvalue={text}
          fullWidth={true}
          multiLine={true}
          hintText={this.context.getIntlMessage('note.yourNote')}
        />
      );
    }
    /*if (this.state.mouseOver) {
      colorChooser = <ColorChooser onSelect={::this.chooseColor} color={color}/>;
    }*/
    return (
      <div style={this.getNoteStyle(materialColor)} className={css.root}>
        {noteText}
        <div onMouseEnter={::this.mouseEnter} onMouseLeave={::this.mouseLeave}>
          <Icons.Note
            onTouchTap={::this.toggle}
            style={this.getIconStyle()}
            color={iconColor}
            hoverColor={hoverColor}
          />
          {/*
        {colorChooser}*/}
        </div>
      </div>
    );
  }
}

const colors = [
  'red',
  'purple',
  'pink',
  'deepPurple',
  'indigo',
  'blue',
  'lightBlue',
  'cyan',
  'coursio',
  'teal',
  'green',
  'lightGreen',
  'lime',
  'yellow',
  'amber',
  'orange',
  'deepOrange',
  'brown',
  'grey',
  'blueGrey'
];

class ColorChooser extends Component {
  getChooserStyle(color) {
    const materialColor = Colors.Colors[color][500];
    return Object.assign(
      {
        backgroundColor: materialColor.material
      },
      styles.colorChoice
    );
  }

  choose(color) {
    if (this.props.onSelect) {
      this.props.onSelect(color);
    }
  }

  render() {
    return (
      <div style={styles.colorChooser}>
        <Paper
          style={{
            width: 28 * 4 + 4,
            padding: Spacing.desktopGutterMini / 4,
            backgroundColor: Colors.Colors.fullWhite
          }}
        >
          {colors.map(color => {
            return (
              <div
                key={color}
                onTouchTap={this.choose.bind(this, color)}
                style={this.getChooserStyle(color)}
              />
            );
          })}
        </Paper>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Note.js